/**
 * Stellt einen einfachen Comparator zur Verfügung, der benutzt werden kann, um typische Auswahl-Arrays zu sortieren.
 * Gibt eine Comparator-Funktion zurück, die z.B. für Array.sort() verwendet werden kann.
 *
 * @param sortAttributeGetter Kann verwendet werden, um eine eigene Function zum Abrufen des Sortier-Wertes zu
 *                            verwenden
 */
export default function useSimpleComparator(sortAttributeGetter) {
    return (a, b) => {
        if (sortAttributeGetter && typeof sortAttributeGetter === "function") {
            return sortAttributeGetter(a).localeCompare(sortAttributeGetter(b));
        } else if (a.bezeichnung) {
            return a.bezeichnung.localeCompare(b.bezeichnung);
        } else if (a.value) {
            if (typeof a.value === "number") {
                return a.value - b.value;
            } else if (typeof a.value === "string" ) {
                return a.value.localeCompare(b.value);
            }
        }

        return 0;
    }
}

